import { log } from '../utils/debug';
import { onPianoEnabledChange } from '../utils/piano';

export function initPiano(subscriptionManager) {
  onPianoEnabledChange(() => {
    if (subscriptionManager) {
      subscriptionManager.isSubscribed().then((isSubscribed) => {
        if (isSubscribed) {
          subscriptionManager.sync().then(() => {
            log.debug('Piano Opt-Out');
          });
        }
      });
    }
  });
}
